import { toPng } from "html-to-image";

export async function exportStoryImage(node) {
  if (!node) throw new Error("Card not ready");
  const images = Array.from(node.querySelectorAll("img"));
  await Promise.all(images.map(image => Promise.race([
    image.decode().catch(() => {}),
    new Promise(resolve => setTimeout(resolve, 8000)),
  ])));
  await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
  const missingPhoto = node.dataset.exportPhotoStatus === "unavailable" || images.some(image => !image.complete || image.naturalWidth === 0);
  const dataUrl = await toPng(node, {
    width: 800, height: 800, pixelRatio: 1, cacheBust: false, includeQueryParams: true, skipFonts: true,
    filter: element => element.tagName !== "IMG" || (element.complete && element.naturalWidth > 0),
    imagePlaceholder: "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=",
  });
  return { dataUrl, missingPhoto };
}